/**
 * Tipos de transação
 */
export const TRANSACTION_TYPES = {
  INCOME: 'income',
  EXPENSE: 'expense',
  TRANSFER: 'transfer',
};

export const TRANSACTION_TYPE_LABELS = {
  income: 'Receita',
  expense: 'Despesa',
  transfer: 'Transferência',
};

export const TRANSACTION_TYPE_COLORS = {
  income: 'text-green-600',
  expense: 'text-red-600',
  transfer: 'text-blue-600',
};

/**
 * Tipos de conta
 */
export const ACCOUNT_TYPES = {
  CHECKING: 'checking',
  SAVINGS: 'savings',
  INVESTMENT: 'investment',
  CREDIT_CARD: 'credit_card',
  CASH: 'cash',
  OTHER: 'other',
};

export const ACCOUNT_TYPE_LABELS = {
  checking: 'Conta Corrente',
  savings: 'Poupança',
  investment: 'Investimento',
  credit_card: 'Cartão de Crédito',
  cash: 'Dinheiro',
  other: 'Outro',
};

/**
 * Frequências de recorrência
 */
export const FREQUENCIES = {
  DAILY: 'daily',
  WEEKLY: 'weekly',
  BIWEEKLY: 'biweekly',
  MONTHLY: 'monthly',
  YEARLY: 'yearly',
};

export const FREQUENCY_LABELS = {
  daily: 'Diário',
  weekly: 'Semanal',
  biweekly: 'Quinzenal',
  monthly: 'Mensal',
  yearly: 'Anual',
};

/**
 * Cores disponíveis para categorias/contas
 */
export const COLORS = [
  { name: 'Vermelho', value: '#EF4444' },
  { name: 'Laranja', value: '#F97316' },
  { name: 'Amarelo', value: '#EAB308' },
  { name: 'Verde', value: '#22C55E' },
  { name: 'Azul', value: '#3B82F6' },
  { name: 'Índigo', value: '#6366F1' },
  { name: 'Roxo', value: '#A855F7' },
  { name: 'Rosa', value: '#EC4899' },
  { name: 'Cinza', value: '#6B7280' },
  { name: 'Ciano', value: '#06B6D4' },
];

/**
 * Ícones de bancos
 */
export const BANK_ICONS = {
  nubank: '💜',
  inter: '🧡',
  itau: '🔶',
  bradesco: '🔴',
  santander: '🔴',
  bb: '💛',
  caixa: '🔵',
  c6: '⬛',
  btg: '🔵',
  xp: '⬛',
  rico: '🟠',
  clear: '🔵',
  other: '🏦',
};

/**
 * Planos
 */
export const PLANS = {
  FREE: 'free',
  PRO: 'pro',
  FAMILY: 'family',
};

export const PLAN_LABELS = {
  free: 'Gratuito',
  pro: 'Profissional',
  family: 'Família',
};

/**
 * Meses do ano
 */
export const MONTHS = [
  'Janeiro', 'Fevereiro', 'Março', 'Abril',
  'Maio', 'Junho', 'Julho', 'Agosto',
  'Setembro', 'Outubro', 'Novembro', 'Dezembro',
];

export const MONTHS_SHORT = [
  'Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun',
  'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez',
];

export default {
  TRANSACTION_TYPES,
  TRANSACTION_TYPE_LABELS,
  TRANSACTION_TYPE_COLORS,
  ACCOUNT_TYPES,
  ACCOUNT_TYPE_LABELS,
  FREQUENCIES,
  FREQUENCY_LABELS,
  COLORS,
  BANK_ICONS,
  PLANS,
  PLAN_LABELS,
  MONTHS,
  MONTHS_SHORT,
};
